<template>
  <div>

    <div class="search-box mt-10">
      <el-button style="float:right" type="success" icon="el-icon-circle-plus-outline" @click="doAdd" >新增</el-button>
      <el-form :inline="true" :model="formData" class="demo-form-inline" size="mini">
        <el-form-item label="标签">
          <el-input 
          v-model="formData.tagName"
          clearable :readonly="isSearching"
          placeholder="请输入标签" 
          @keyup.enter.native="doSearch"
          @clear="doReset"
          @blur="doBlur"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="doSearch" :loading="isSearching">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-divider></el-divider>

    <div>
      <el-table
        :data="list"
        size="mini"
        border
        stripe
      >
        <el-table-column
          prop="tagId"
          label="tagId"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="tagName"
          label="标签名">
          <template slot-scope="scope">
            <el-tag @click="doSearchTagUser(scope.$index, scope.row)">{{scope.row.tagName}}</el-tag> 
          </template>
        </el-table-column>
        <el-table-column
          prop="seTime"
          width="120"
          align="center"
          label="同步时间">
        </el-table-column>
        <el-table-column
          prop="updateAt"
          label="修改时间"
          align="center"
          width="90">
        </el-table-column>
        <el-table-column
          prop="createAt"
          label="创建时间"
          align="center"
          width="90">
        </el-table-column>

        <el-table-column 
          label="操作" 
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="doEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="doDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-divider></el-divider>
      <div class="ta-r">
        <el-pagination
          background
          hide-on-single-page
          layout="prev, pager, next"
          @current-change="doChangePage"
          :page-size="pagination.size"
          :current-page="pagination.page"
          :total="total">
        </el-pagination>
      </div>
      
    </div>

    <TagForm :data="currentData" :show.sync="showFormEdit" :isEdit="isEdit"/>

  </div>
</template>

<script>
import TagForm from '@/components/TagForm';
export default {
  name: 'TagsList',
  components: {
    TagForm
  },
  data(){
    return {
      formData:{
        tagName:"",
      },
      pagination:{
        size:10,
        page:1,
      },
      total:0,
      list:[],
      isSearching:false,
      showFormEdit:false,
      currentData:{},
      isEdit:false
    };
  },
  watch: {
    showFormEdit(newData){
      if(!newData){
        this.doSearch(false);
        this.currentData = {};
      }
    }
  },
  mounted () {
    
    this.doSearch();
  },
  methods:{
    doSearch(resetPage = true){
      var formData = {...this.pagination,...this.formData};
      if(resetPage)formData.page = 1;
      var params = this.$root.object2urlparams(formData);
      
      this.getList(`/api/v1/tags?${params}`);
    },
    doChangePage(currentPage){
      var formData = {...this.pagination,...this.formData};
      formData.page = currentPage;
      var params = this.$root.object2urlparams(formData);
      this.getList(`/api/v1/tags/?${params}`);
    },
    doDelete(index,row){
      this.$confirm('此操作将永久删除该标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.delete(`/api/v1/tags/${row.tagId}`).then(res=>{
          if(!res)return;
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.doSearch(false);
        })
        
      }).catch(() => {
                
      });
      
    },
    doEdit(index,row){
      this.currentData = row;
      this.isEdit = true;
      this.showFormEdit = true;
    },
    doSearchTagUser(index,row){
      this.$router.push('/Home/Collect/User/List/Tag/'+row.tagName);
    },
    doAdd(){
      this.currentData = {};
      this.isEdit = false;
      this.showFormEdit = true;
    },
    getList(url){
      this.isSearching = true;
      this.request.get(url).then(res=>{
        this.isSearching = false;
        if(!res){this.list = [];return ;}
        this.list = res.results;
        this.list.forEach(d=>{
          var seTime = '';
          if(d.extension && d.extension.se && d.extension.se.payload && d.extension.se.payload.startAt){
            seTime = d.extension.se.payload.startAt +'~'+ d.extension.se.payload.endAt;
          }
          this.$set(d,'seTime',seTime);
        })
        this.total = res.total;
      });
    },
    doBlur(){

    },
    doReset(){
      this.list = [];
      this.total = 0;
      this.formData.tagName = '';
      this.pagination.page = 1;
      this.doSearch();
      // this.formData.collectType = 'INS';

    }
  }
  
  

}
</script>

<style>

</style>
